import React from "react";

import { Col, Form, Row } from "react-bootstrap";

import { isEmpty } from "lodash";
import { Controller, useWatch } from "react-hook-form";

import { useRegisterFormContext } from "@pages/register/hooks/useRegisterFormContext";

import { DomesticBankDetails } from "./DomesticBankDetails";
import { OverseasBankDetails } from "./OverseasBankDetails";

import styles from "./index.module.scss";

export const BankDetails = () => {
  const { control, errors } = useRegisterFormContext();

  const bankType = useWatch({
    control,
    name: "bank_details.bank_type",
  });

  return (
    <div className={styles["form-section"]}>
      <Row>
        <Col md={12} sm={12}>
          <Form.Group>
            <Form.Label>Is your bank domestic or overseas?</Form.Label>
            <Row>
              <Col>
                <Controller
                  name="bank_details.bank_type"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Form.Check
                        className={styles["form-check"]}
                        type="radio"
                        label="Domestic"
                        value="DOMESTIC"
                        checked={field.value === "DOMESTIC"}
                        onChange={() => field.onChange("DOMESTIC")}
                      />
                    </>
                  )}
                />
              </Col>
              <Col>
                <Controller
                  name="bank_details.bank_type"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Form.Check
                        className={styles["form-check"]}
                        type="radio"
                        label="Overseas"
                        value="OVERSEAS"
                        checked={field.value === "OVERSEAS"}
                        onChange={() => field.onChange("OVERSEAS")}
                      />
                    </>
                  )}
                />
              </Col>
            </Row>
          </Form.Group>
        </Col>
      </Row>

      {bankType === "DOMESTIC" && <DomesticBankDetails control={control} errors={errors} />}
      {bankType === "OVERSEAS" && <OverseasBankDetails control={control} errors={errors} />}
      {!isEmpty(errors?.bank_details) && (
        <div className={styles["form-help-text"]}>Please review above before processing.</div>
      )}
    </div>
  );
};
